module.exports = __webpack_public_path__ + "img/Akute_Gefahr_durch_Luftmangel.39751e23.svg";